<template>
  <div>
    {{ selectedPlan.cartCapacity }} {{ selectedPlan.cartCapacityUnit }} • {{ $money(selectedPlan.amount) }}  • {{ subscriptionCycleDesc }}
  </div>
</template>
<script setup>
import { getSubscriptionCycleDesc } from '@/common/product-unit';

const props = defineProps({
  selectedPlan: {
    type: Object,
    required: true
  }
});

const subscriptionCycleDesc = getSubscriptionCycleDesc(props.selectedPlan?.billing_cycle);
</script>

<style scoped lang="scss">
.opc-inline-block {
  display: inline-block;
}
</style>
